import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import odooApi from "../services/odooApi";

export const PageViewTracker = () => {
  const location = useLocation();
  const lastTrackedPageRef = useRef("");

  useEffect(() => {
    const pageUrl = `${location.pathname}${location.search}`;
    if (lastTrackedPageRef.current === pageUrl) {
      return;
    }

    lastTrackedPageRef.current = pageUrl;
    odooApi.trackPageView(pageUrl);
  }, [location.pathname, location.search]);

  return null;
};

export default PageViewTracker;
